import { render, staticRenderFns } from "./DeleteClassesUsers.vue?vue&type=template&id=74f9792c&scoped=true&"
import script from "./DeleteClassesUsers.vue?vue&type=script&lang=js&"
export * from "./DeleteClassesUsers.vue?vue&type=script&lang=js&"
import style0 from "./DeleteClassesUsers.vue?vue&type=style&index=0&id=74f9792c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f9792c",
  null
  
)

export default component.exports